<template>
<el-container style="width: 100%; height: 100vh;">
  <el-aside class="left-menu-area">
    <div class="small-logo row"><img src="/database.svg" style="width: 20px; height: 20px"><span style="margin-left:10px">ChatBI</span></div>
    <div class="row" style="width:100%;padding:10px; box-sizing: border-box">
      <div class="primary-button" @click="getTables">表格列表</div>
    </div>

    <div class="records">
      <div v-for="(t, index) in tables" :key="index" @click="getExamples(t[0])">
        <el-tooltip class="box-item" effect="light" :content="t[0]" placement="right">
          <div class="record">{{t[0]}}</div>
        </el-tooltip>
      </div>
    </div>


  </el-aside>
  <el-container style="flex-grow: 1.0; height:100vh; display: flex; flex-direction: column; overflow: auto">
    <div class="row-between" style="width: 100%; height:auto; background-color:ghostwhite; margin-left: 0px; padding: 10px;box-sizing: border-box;border-bottom: 1px solid #EBEEF5">
     <div class="row" style="border: 0px solid #E4EDEF; width:max-content; border-radius: 4px">
      <el-button @click="getTableSchema" plain>
          <el-icon><Setting /></el-icon>
          <div style="margin-left: 5px">schema</div>
      </el-button>
      <el-button @click="getExamples(currentTable)" plain>
          <el-icon><Postcard /></el-icon>
          <div style="margin-left: 5px">示例数据</div>
      </el-button>

      <el-button  @click="getTableExplanation" plain>
        <el-icon><Refresh /></el-icon>
        <div style="margin-left: 5px">表格描述</div>
      </el-button>
     </div>

      <div class="row" style="border: 0px solid #E4EDEF; width:max-content;border-radius: 4px">
        <div style="font-size: 14px;">单个:</div>
      <el-button  @click="getTableFields" style="margin-left: 5px" color="#6467F0" :dark="false" plain>
          <div style="margin-left: 5px">字段描述</div>
      </el-button>
      <el-button  @click="getTableFieldFuns" style="margin-left: 5px" color="#6467F0" :dark="false" plain>
          <div style="margin-left: 5px">字段功能</div>
      </el-button>
      <el-button @click="getTableQuestions"  color="#6467F0" :dark="false" plain>
        <el-icon><Key /></el-icon>
        <div style="margin-left: 5px">问题详情</div>
      </el-button>
      <el-button @click="getTableNames"  color="#6467F0" :dark="false" plain>
        <el-icon><Memo /></el-icon>
        <div style="margin-left: 5px">表格名称</div>
      </el-button>
      </div>

      <div class="row" style="border: 0px solid #E4EDEF; width:max-content;border-radius: 4px">
        <div style="font-size: 14px;">批量:</div>
        <el-button  @click="getTotalTableFields" style="margin-left: 5px" color="#6467F0" :dark="false" plain>
          
          <div style="margin-left: 5px">字段详情</div>
        </el-button>
        <el-button @click="getTotalTableQuestions"  color="#6467F0" :dark="false" plain>
          <el-icon><Key /></el-icon>
          <div style="margin-left: 5px">问题详情</div>
        </el-button>
        <el-button @click="getTotalTableNames"  color="#6467F0" :dark="false" plain>
          <el-icon><Memo /></el-icon>
          <div style="margin-left: 5px">表格名称</div>
        </el-button>
      </div>




      <div class="row" style="border: 0px solid #E4EDEF; width:max-content; padding:15px; border-radius: 4px">
      <el-button @click="upsertData" type="success" :dark="true">
          <el-icon><SuccessFilled /></el-icon>
          <div style="margin-left: 5px">保存</div>
      </el-button>

      <el-button  @click="clearTableExplanation" type="danger" :dark="true">
        <el-icon><Refresh /></el-icon>
        <div style="margin-left: 5px">清空表格描述</div>
      </el-button>
      </div>
    </div>
    <div v-if="query_info" class="row-evenly" style="height:200px; width: 100%; overflow: auto">
      <el-button style="font-weight:normal;font-size: 18px; color: #6467f0; background-color: white; border: none" loading>{{loadText}}</el-button>
    </div>
    <div v-if="!query_info" style="flex-grow: 1.0; width: 100%; overflow: auto">
      <div v-if="currentMode === '重新生成'" class="scroll-container" ref="contentRef" @scroll="handScroll"
         style="margin-top:0px;height:100%;padding:0px;width:100%;  box-shadow: 0 0px 2px rgba(0, 0, 0, 0.1); border-radius:0px;  box-sizing: border-box; background-color: white">
        <v-md-editor v-if="content !== '' && stream" v-model="content" :mode="edit_mode"/>

        <div v-for="(desc, i) in currentTableDesc" :key="i"  style="padding:8px;box-sizing:border-box;margin-top:px;width: 100%; margin-left:0px;border-bottom: 0.5px solid #E4EDEF;" class="column">
        <div class="row">
      
        <div v-if="desc.editContent.type === 'Quest'" style="flex-grow: 1.0; margin-left: 15px" class="column">
         <div class="row">
             
         <el-icon style="color:#6467F0"><QuestionFilled /></el-icon>
         <el-input v-model="desc.editContent.Question" style="flex-grow: 1.0; margin-left: 15px"></el-input>
             
          <el-button  style="margin-left:15px; border:none;color:#6467F0">
            <span style="margin-left: 5px">隐藏</span>
          </el-button>
         </div>
         <div v-if="true" style="color:#67C23A; width:100%; padding:5px; box-sizing:border-box" class="row">
           <div style="flex-grow: 1.0;margin-left: 25px; color:#6467F0; padding:10px; box-sizing:border-box">{{desc.editContent.SQL}}</div>
           <el-button style="margin-left:15px; border:none;color:#6467F0">
            <span style="margin-left: 5px">查询</span>
          </el-button>
         </div>
        </div>
        <el-input v-if="desc.editContent.type === 'undefine'" 
                  v-model="desc.text" style="flex-grow: 1.0; margin-left: 15px"></el-input>
        <div v-if="desc.editContent.type === 'Desc'" style="flex-grow: 1.0; margin-left: 15px" class="row">
        <el-icon style="color:#E6A23C"><InfoFilled /></el-icon>
        <el-input v-model="desc.editContent.TableNameDesc" style="flex-grow: 1.0; margin-left: 15px"></el-input>
        </div>
        <div v-if="desc.editContent.type === 'Field'" style="flex-grow: 1.0; margin-left: 15px" class="row">
          
          <el-icon style="color:#909399"><InfoFilled /></el-icon>
          <el-input v-model="desc.editContent.Field" style="width:150px; margin-left: 15px"></el-input>
          <el-input v-model="desc.editContent.FieldDesc" style="width:150px; margin-left: 15px"></el-input>
          <el-input v-model="desc.editContent.FieldJoin" style="width:150px; margin-left: 15px"></el-input>
          <el-input v-model="desc.editContent.FieldEnum" style="width:150px; margin-left: 15px"></el-input>
          <el-input v-model="desc.editContent.FieldFunc" style="flex-grow: 1.0; margin-left: 15px"></el-input>
        </div>
          <el-button  @click="updateRecord(desc)" style="margin-left:15px; border:none;color:#6467F0">
            <span style="margin-left: 5px">保存</span>
          </el-button>
          <el-button @click="deleteRecord(desc, i)" style="margin-left:5px; border:none;color:#6467F0">
            <span style="margin-left: 5px">删除</span>
          </el-button>
        </div>
       
        </div>
      </div>
    <div v-if="currentMode === 'schema' || currentMode === '示例数据'" 
        style="margin-top:0px;height:100%;padding:0px;width:100%; border-radius:0px;box-sizing: border-box;">
      <el-auto-resizer>
        <template #default="{height, width}">
          <el-table-v2
              :columns="data_columns"
              :data="tableData"
              :width="width"
              :height="height"
              :align="center"
              fixed>
          </el-table-v2>
        </template>
      </el-auto-resizer>
    </div>
    </div>
    <div v-if="!query_info && currentTable !== ''" class="title">
      {{currentTable}}表格
    </div>
  </el-container>
<el-aside style="width:20px; height:100vh; background-color:ghostwhite; border-left: 0px solid #E3E4EF">
</el-aside>
</el-container>
</template>

<script setup>
import {ref, onMounted, watch} from "vue";
import axios from "axios";
import {fetchEventSource} from "@microsoft/fetch-event-source";
import { ElMessage } from 'element-plus';
    
const tables = ref([]);
const height = ref(50);
const width = ref(100);
const data_columns = ref([]);
const tableData = ref([]);
const content = ref("");
const contentRef = ref(null);
const prompt_id = ref("bd344d5d-5371-4810-8190-afc2d59372bf");
const query = ref("");
const currentTable = ref("");
const edit_mode = ref("preview");
const query_info = ref(false);    
const currentMode = ref("重新生成");
const currentTableDesc = ref([]);
const loadText = ref("努力加载信息中");
const stream = ref(true);


       
const deleteRecord = async (desc, i) =>{
    const resp = await axios.post('/vector', {
    name: 'table_schema', // 查询参数
    record: desc,
    op: 'delete'
      },
      {
        headers: {
          'Content-Type': 'application/json'
        },
      }
  );
    console.log(resp.data)
 
    currentTableDesc.value.splice(i, 1);
    ElMessage({
    message: '信息已删除',
    type: 'success',
  })   

}

const updateRecord = async (desc) =>{
    const resp = await axios.post('/vector', {
    name: 'table_schema', // 查询参数
    record: desc,
    op: 'update'
    },
      {
        headers: {
          'Content-Type': 'application/json'
        },
      }
  );
  console.log(resp.data);
  ElMessage({
    message: '已更新成功',
    type: 'success',
  })   


}



const upsertData = async() =>{
  const resp = await axios.post('/vector', {
    name: 'table_schema', // 查询参数
    data: [{
            'text': content.value,
            'table_name': currentTable.value
    }], // 可以添加多个参数
    op: 'upsert'
      },
      {
        headers: {
          'Content-Type': 'application/json'
        },
      }
  );
  console.log(resp);
  content.value = '';
  currentTableDesc.value = resp.data.response;
  ElMessage({
    message: "表格"+currentTable.value + '信息已更新成功',
    type: 'success',
  })   
}


const currentTableSchema = ref("");
let ctrl = new AbortController();
    
    
const dialogues = ref([]);
const trigger = ref("");
const currentContent = ref("");
    
const sendTotalPrompt = async () => {
     if (currentTable.value === ""){
        ElMessage({
          message: "尚未选定表格名称，无法生成",
          type: 'error',
        })
        return;
     }
     currentMode.value = "重新生成";
     query_info.value = true;
     loadText.value = "获取示例数据 ...";
     await getData(currentTable.value);
     if(tableData.value.length === 0){
        ElMessage({
         message: "表格"+ currentTable.value + '为空，无法生成.',
         type: 'error',
        })
     }else{
        loadText.value = "获取示例数据成功";
        const res = await executeMysql("describe " + currentTable.value, "query", "str");
        query.value = '## 表格schema ##\n' + res.response + "\n";
        currentTableSchema.value = query.value;
        loadText.value = "获取表格采样数据...";
        const resp0 = await getTableDesc();
        currentTableSchema.value = currentTableSchema.value + "\n" + resp0.column;
        query.value = currentTableSchema.value + resp0.row + "\n";
        console.log(query.value);
        content.value = "";
        dialogues.value = [];
        currentTableDesc.value = [];
        dialogues.value.push({"role": "user", "content": query.value});
        loadText.value = "成功获取表格采样数据";
        await sendPrompt();
     }
}

   
    
const sendPrompt = async () => {
  if (currentTable.value === ""){
      ElMessage({
         message: "尚未选定表格名称，无法生成表格描述信息",
         type: 'error',
        })
    return;
   }
  

  try {
    currentContent.value = '';
    loadText.value = "等待回复中 ...";
    await fetchEventSource('/chat2users', {
      method: "POST",
      body: JSON.stringify({
        messages: dialogues.value,
        prompt_id: prompt_id.value,
        trigger: trigger.value
      }),
      headers: {
        'Content-Type': 'application/json'
      },
      signal: ctrl.signal,
      onopen: (resp) => {
        if (resp.ok && resp.status === 200) {
          console.log('Connection established');
        } else {
          console.error('Failed to connect:', resp);
        }
        query_info.value = false;
      },
      onmessage: (message) => {
        if (message.event === ''){
          content.value += "  \r";
          currentContent.value += "  \r";
        }else{
          content.value += message.data;
          currentContent.value += message.data;
        }
      },
      onerror: (err) => {
        console.error('Error occurred:', err);
        if (ctrl && !ctrl.signal.aborted){
          ctrl.abort();
          ctrl = new AbortController();
        }
      },
      onclose: ()=> {
        console.log('Connection closed');
      },
      onfinish:() => {
        console.log('Finished receiving events');
      }
    });
  } catch (err) {
    console.error('Unexpected error:', err);
  }
}

function handScroll(event){
  const {scrollTop, scrollHeight, clientHeight} = event.target;
  if (scrollTop && scrollHeight && clientHeight && scrollTop + clientHeight >= scrollHeight){
    contentRef.value.scrollTop = scrollHeight;
  }
}

function scrollToBottom(){
  if (contentRef.value){
    contentRef.value.scrollTop = contentRef.value.scrollHeight;
  }
}

watch(content,()=>{
  console.log(content)
  scrollToBottom();
})

const getTableSchema = async() => {
  currentMode.value = "schema";
  query_info.value = true;
  content.value = '';
  const res = await executeMysql("describe " + currentTable.value, "query", '');
  data_columns.value = res.columns;
  tableData.value = res.response;
  query_info.value = false;
}

const getTableExplanation = async () =>{
    content.value = "";
    currentMode.value = "重新生成";
    if (currentTable.value === ''){
        return;
    }
  query_info.value = true;
  const resp = await axios.post('/vector', {
        table_name: currentTable.value, // 查询参数
        coll_name: 'table_schema',
        op: 'accGet'
      },
      {
        headers: {
          'Content-Type': 'application/json'
        },
      }
  );
  console.log(resp);
  currentTableDesc.value = resp.data.response;
  query_info.value = false;
}

const clearTableExplanation = async () =>{
  if (currentTable.value === ''){
    ElMessage({
      message: "请先选择表格，再清空表格描述",
      type: 'error',
    })
    return;
  }
  const resp = await axios.post('/vector', {
        table_name: currentTable.value, // 查询参数
        name: 'table_schema',
        op: 'clear_table'
      },
      {
        headers: {
          'Content-Type': 'application/json'
        },
      }
  );
  console.log(resp);
  if (resp.status === 200){
    ElMessage({
      message: resp.data.msg,
      type: 'success',
    })
  }
  if (resp.status === 400){
    ElMessage({
      message: resp.data.msg,
      type: 'error',
    })
  }
}

const getTableFields = async () =>{
  prompt_id.value = "28047b99-ba20-4c8b-a9f3-570320ebfb76";
  trigger.value = "\n## 开始生成字段说明信息以及表格中文名称 ##\n";
  await sendTotalPrompt();
}

const getTableFieldFuns = async () =>{
//   currentMode.value = "";
  stream.value = false;
  for (let i = 0; i < currentTableDesc.value.length; i += 1){
      if (currentTableDesc.value[i].editContent.type === "Field"){
           const resp = await axios.post('/db', {
                  op: "table_desc",
                  table_name: currentTable.value,
                  field_name: currentTableDesc.value[i].editContent.Field

               }, {
                headers: {
                  'Content-Type': 'application/json'
                },
              });
           query.value = resp.data.examples + resp.data.field + "\n" + currentTableDesc.value[i].text;
           prompt_id.value = "58e8f44a-c68e-4d7f-bd0b-04920e7d23a4";
           trigger.value = "\n## 开始针对" + currentTableDesc.value[i].editContent.Field + "字段取值理解 ##\n";
           dialogues.value = [];
           dialogues.value.push({"role": "user", "content": query.value});  
           // sendPrompt();
           const resps = await axios.post('/chat2apps', {
                  params: {
                    messages: dialogues.value,
                    prompt_id: prompt_id.value,
                    trigger: trigger.value
                  }
                }, {
                  headers: {
                    'Content-Type': 'application/json'
                  },
                }
           );
           console.log(resps.data.response);

           let cols = resps.data.response.split('@');
           if (cols.length === 3){
               if (cols[0] === currentTableDesc.value[i].editContent.Field){
                   currentTableDesc.value[i].editContent.Join = cols[1];
                   currentTableDesc.value[i].editContent.Dtype = cols[2];
               }
           }
      }
  } 
  stream.value = true;
}

const getTotalTableFields = async () =>{
  for(let ii = 0; ii < tables.value.length; ii += 1) {
    currentTable.value = tables.value[ii][0];
    await getTableFields();
    await upsertData();
  }
}

const getTableQuestions = async () =>{
  prompt_id.value = "b112696e-daae-421b-808d-463aa91f919f";
  trigger.value = "\n## 开始生成表格相关的业务问题 ##\n";
  await sendTotalPrompt();
}

const getTotalTableQuestions = async () =>{
  for(let ii = 0; ii < tables.value.length; ii += 1) {
    currentTable.value = tables.value[ii][0];
    await getTableQuestions();
    if(tableData.value.length !== 0){
      await upsertData();
    }
  }
}

const getTableNames = async () =>{
  prompt_id.value = "62b13846-41ab-4a28-94a1-ffd6d3f40ed6";
  trigger.value = "\n## 开始生成表格中文名称 ##\n";
  await sendTotalPrompt();
}

const getTotalTableNames = async () =>{
  for(let ii = 0; ii < tables.value.length; ii += 1) {
    currentTable.value = tables.value[ii][0];
    await getTableNames();
    if(tableData.value.length !== 0){
      await upsertData();
    }
  }
}

const getExamples = async(table_name) =>{
  currentMode.value = "示例数据";
  query_info.value = true;
  await getData(table_name);
  query_info.value = false;
}


const getData = async (table_name) =>{
  currentTableDesc.value = [];
  content.value = '';
  currentTable.value = table_name;
  const res1 = await executeMysql("select * from " + table_name + " limit 100;", "query", '');
  data_columns.value = res1.columns;
  tableData.value = res1.response;
}

const getTables = async () =>{
  const res = await executeMysql("show tables;", "","")
  tables.value = res.response;
}

const getTableDesc = async () =>{
  const resp = await axios.post('/db', {
          op: 'table_desc',
          table_name: currentTable.value
      }, {
        headers: {
          'Content-Type': 'application/json'
        },
      }
  );
  console.log(resp);
  return resp.data.response;
}

const executeMysql = async (sen, mode, format) =>{
  const resp = await axios.post('/db', {
          op: "run_sql",
          mysql: sen, 
          mode: mode, 
          format: format
      }, {
        headers: {
          'Content-Type': 'application/json'
        },
      }
  );
  console.log(resp);
  return resp.data;
}

onMounted(async ()=>{
  height.value = 50;
  width.value = 100;
  await getTables();
})

</script>

<style scoped>

.scroll-container{
  overflow: auto;
  scrollbar-width:none;
}

.primary-button{
  background-color: #6467f0;
  color: white;
  padding: 6px 25px;
  border-radius: 8px;
  width: 80%;
  text-align: center;
  box-sizing: border-box;
}

:deep(.scroll-container){
  .el-input{
    --el-input-focus-border: 1px solid white;
    --el-input-border-color: white;
    --el-input-focus-border-color: #6467F0;
    --el-input-hover-border-color: #6467F0;
    --el-input-width: auto;
  }
}

/* 自定义滚动条样式 */
.scroll-container::-webkit-scrollbar {
  /*width: 5px; !* 滚动条宽度 *!*/
  /*height:20px;*/
  display: none; /* 隐藏滚动条 */
}

.small-logo{
  font-size: 20px;
  font-weight: bold;
  margin-top: 10px;
  width: 140px;
  margin-left: 10%;
  background-color: ghostwhite;
  /*box-shadow: 0 0px 2px rgba(0, 0, 0, 0.1);*/
  padding:10px 20px;
  border-radius: 12px;
}

/*.small-logo:hover{*/
/*  border: 2px solid #6467f0;*/
/*}*/

.selected{
  background-color: #6467f0;
  color: white;
}

.left-menu-area{
  width: 200px;
  background-color: ghostwhite;
  border-right: 1px solid #EBEEF5;
  display: flex;
  flex-direction: column;
}

/*.plain-button{*/
/*  width: 80%;*/
/*  margin-left: 10%;*/
/*  margin-top: 15px;*/
/*  font-weight: normal;*/
/*}*/

/*.plain-button:hover{*/
/*  background-color: #6467f0;*/
/*  border: none;*/
/*  border-radius: 4px;*/
/*  color: white;*/
/*}*/

.records{
  flex-grow: 1.0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow-y: auto;
  overflow-x: hidden;
  padding:0px 15px 30px 15px;
  box-sizing: border-box;
  -ms-overflow-style: none;  /* Internet Explorer 10+ */
  scrollbar-width: none;  /* Firefox */
}

.records::-webkit-scrollbar {
  display: none;  /* WebKit 浏览器 */
}
    
.field-record{
 background-color:rgb(224.6, 242.8, 215.6);
 color: green;
 margin-top:15px;
 margin-left:20px;
 border-radius:8px;
 padding:8px;
 width:max-content;
 border:1px solid green;
}
    
.question-record{
 background-color:rgb(253, 225.6, 225.6);
 color: #F56C6C;
 margin-top:15px;
 margin-left:20px;
 border-radius:8px;
 padding:8px;
 width:max-content;
 border:1px solid #F56C6C;
}
    
.desc-record{
 background-color:rgb(250, 236.4, 216);
 color: #E6A23C;
 margin-top:15px;
 margin-left:20px;
 border-radius:8px;
 padding:8px;
 width:max-content;
 border:1px solid #E6A23C;
}
   
.record{
  width:100%;
  text-align: left;
  padding:8px 15px;
  border-radius: 4px;
  font-size: 15px;
  margin-top: 0px;
  color: gray;
  white-space: nowrap;
  overflow: hidden;
  box-sizing: border-box;
  text-overflow: ellipsis;
}

.record:hover{
  background-color: white;
  border: 1px solid #EBEEF5;
  border-radius: 8px;
  color: #6467f0;
}

.adjust-button{
  background-color: white;
  border: none;
  border-radius: 8px;
  width: max-content;
  border: 1px solid #EBEEF5;
}

.adjust-button:hover{
  background-color: #6467f0;
  color: white;
  border: 1px solid #6467f0;
}

.title{
  padding:10px;
  width:100%;
  display:flex;
  flex-direction:row;
  background-color: ghostwhite;
  color: black;
  font-weight:bold;
  font-size:14px;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  border-top: 1px solid #EBEEF5
}

.v-md-editor{
  color: gray
}

</style>